import { Alert, Flex } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';

import MessageBubble from '../MessageBubble';

import s from './Dialog.module.scss';

type DialogProps = {
  bottomRef: React.RefObject<HTMLDivElement | null>;
};

const Dialog: React.FC<DialogProps> = ({ bottomRef }) => {
  const { messages, meta, toolCallHistory } = useOrganizationChatAiPageStore();

  const handleOpenActivity = React.useCallback(
    (messageId: string) => {
      toolCallHistory.openForMessage(messageId);
    },
    [toolCallHistory],
  );

  return (
    <Flex className={s.root} direction="column" justify="flex-end">
      {messages.map((m, i) => {
        const isAssistant = m.role === 'assistant';
        const activitySummary = isAssistant ? (m.toolCallHistory?.summaryLabel ?? undefined) : undefined;
        const activityMessageId = isAssistant && (m.toolCallHistory?.steps.length ?? 0) > 0 ? String(m.id) : undefined;

        return (
          <MessageBubble
            isLoadingAnswer={meta.isLoading}
            status={m.status}
            key={`${m.id}:${m.createdAt}:${m.role}`}
            role={m.role}
            text={m.text}
            answerId={m.originalId}
            isMarkdown={m.isMarkdown}
            index={i}
            activitySummary={activitySummary}
            activityMessageId={activityMessageId}
            onActivityOpen={handleOpenActivity}
          />
        );
      })}
      {meta.isError && (
        <Alert
          className={s.root__alert}
          color="red"
          icon={<IconAlertCircle />}
          title="Ошибка при формировании ответа"
        />
      )}
      <div ref={bottomRef as React.RefObject<HTMLDivElement>} />
    </Flex>
  );
};

export default observer(Dialog);
